@if (pagination) {
    <div class="product-grid" [ngClass]="{'filter-open': isShowFilter}">
        @for (product of productList | paginate: paginationConfig; track product) {
            <div class="product-card">

                <div class="product-card__image-wrap">
                  <a class="product-card__image mouse-pointer"
                     (click)="openModalProduct(product)"
                     [ngStyle]="{'background-image': 'url(' + getImageUri(product.picture) + ')'}">
                  </a>
                </div>

                <div class="product-card__body">

                    <div class="product-card__meta-row">
                        <p class="product-card__articul"><app-search-code-highlight [code]="product.productCode" [query]="searchKeyword"/></p>
                        <p class="product-card__stock">
                            В наличии: {{ productService.countAvailability(product).toLocaleString() }}
                        </p>
                    </div>

                    <p class="product-card__title mouse-pointer" (click)="openModalProduct(product)">
                        <app-search-code-highlight field="name" [code]="product.header" [productCode]="product.productCode" [query]="searchKeyword"/>
                    </p>

                    @if (!device.isMobile) {
                        <div class="product-card__prices">
                            <app-product-price [product]="product" [showDetails]="true" [showVAT]="true" />
                        </div>
                    } @else {
                        <div class="product-card__prices product-card__prices--mobile">
                            <div class="product-card__price-row">
                                <app-product-price [product]="product" [showDetails]="true" />
                                <span class="product-card__price-label" i18n="@@Sum">cумма</span>
                            </div>
                            <div class="product-card__price-row product-card__price-row--nds">
                                <app-product-price [product]="product" [showDetails]="true" [showVAT]="true" />
                                <span class="product-card__price-label" i18n="@@SumTax">cумма с НДС</span>
                            </div>
                        </div>
                    }
                    <div class="product-card__actions">
                        @if (!isShowcase) {
                            @if (isShowRequestedProducts(product)) {
                                <button nbButton status="primary" size="small"
                                        class="product-card__request-btn"
                                        (click)="openAddToRequestedProducts(product)">
                                    Добавить в товары по запросу
                                </button>
                              <div class="packaging">&nbsp;</div>
                              @if (product.deliveryAtp) {
                                <div class="packaging"><span>Дата готовности:</span> {{ product.deliveryAtp | date: "dd.MM.yyyy" }}</div>
                              } @else {
                                <div>&nbsp;</div>
                              }
                            } @else {
                                <app-add-to-cart [product]="product" [catalog]="false" />
                            }
                        }
                    </div>

                </div>
              <div class="name-table__icons" *ngIf="product?.markers">
                <ng-container *ngFor="let marker of product.markers">
                  <div class="item" *ngIf="11 !== marker.id">
                    <span class="{{marker.icon}}">{{marker.header}}</span>
                  </div>
                </ng-container>
              </div>
            </div>
        }
    </div>
}

<pagination
        [id]="paginationConfig.id"
        [config]="configuration"
        [pagination]="pagination"
        (update)="onPagination($event)"
/>
